export default __webpack_public_path__ + "static/media/ketoparties.283540e0.jpg";